import { STYLES } from "./styles";
import { STYLES as STYLES_V2 } from "./stylesV2";
import { TVariant } from "./types";

export const imageSizes: Record<TVariant, string> = {
  square: "(min-width: 768px) 25vw, 50vw",
  portrait: "(min-width: 768px) 25vw, 50vw",
  wide: "(min-width: 768px) 25vw, 100vw",
};

export const textSize: Record<TVariant, string> = {
  square: STYLES.card.text.size.default,
  portrait: STYLES.card.text.size.default,
  wide: STYLES.card.text.size.small,
};

export const textPlacement: Record<TVariant, string> = {
  square: STYLES.card.text.variant.bottom,
  portrait: STYLES.card.text.variant.top,
  wide: STYLES.card.text.variant.bottom,
};

export const textPlacementV2: Record<TVariant, string> = {
  square: STYLES_V2.card.text.variant.bottom,
  portrait: STYLES_V2.card.text.variant.bottom,
  wide: STYLES_V2.card.text.variant.bottom,
};
